import {
  DATO_DISCOUNT_FIELDS,
  getDatoMarket,
  getMarketORFilter,
  resolvePartnerDiscounts
} from '@shared/cart-js';
import { COUNTRY } from '@shared/cove-ui';
import Axios from 'axios';
import keyBy from 'lodash/keyBy';

const apiEnv =
  (typeof window !== 'undefined' && process.env.NODE_ENV) || 'development';

const token = '7c8a71c5a466ac293a9f9f29233e78';
const defaultPartnerId = apiEnv !== 'production' ? '39770523' : '6400414';

const datoLoad = async (loadCached = true) => {
  const market = getDatoMarket(COUNTRY);
  const marketsFilter = getMarketORFilter(market);

  return Axios.post(
    `https://graphql.datocms.com/${apiEnv !== 'production' ? 'preview/' : ''}`,
    {
      query: /* GraphQL */ `{
      allDiscounts(first: 100, orderBy: [priority_ASC, createdAt_ASC], filter: {OR: [${marketsFilter}], active: {eq: true}}) {
        ${DATO_DISCOUNT_FIELDS}
      }
      partner(filter: {partnerId: {eq: "${defaultPartnerId}"}}) {
        productsList {
          ...productFields
        }
        plansList {
          ...productFields
        }
      }
      partnerSalesConfig(filter: {partner: {eq: "${defaultPartnerId}"}}) {
        discountFilter
        discountsList {
          ${DATO_DISCOUNT_FIELDS}
        }
      }

      allProductCategories(first: 100) {
        id
        name
      }
      payLater {
        maximum
        minimum
        restrictTo {
          id
          sku
        }
      }
    }

    fragment productFields on ProductRecord {
      name
      sku
      createdAt
      pandoId
      productType
      price
      salePrice
      payLaterEligible
      description
      featureList {
        description
      }
      maximumSensorCountOnSite
      recommendation
      floorplanImage {
        url
      }
      primaryImage {
        url
      }
      iconImage {
        url
      }
      category {
        name
        id
      }
      lowInventoryIcon
      outOfStock
      outOfStockAvailabilityText
      position
    }
    `
    },
    {
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${token}`
      },
      timeout: 5000
    }
  )
    .then(({ data: { data }, errors }) => {
      data.payLater.restrictTo = data.payLater
        ? data.payLater.restrictTo.map(product => product.sku)
        : [];
      return {
        products: keyBy(
          [...data.partner.productsList, ...data.partner.plansList],
          'sku'
        ),
        discounts: resolvePartnerDiscounts({
          allDiscounts: data.allDiscounts ?? [],
          partnerSalesConfig: data.partnerSalesConfig,
          market
        }),
        payLater: data.payLater
      };
    })
    .catch(error => {
      console.error(error);
      return { error, ...(loadCached ? import('./datoData') : {}) };
    });
};

export default datoLoad;
